import { useEffect, useRef } from 'react';

/**
 * Lädt regelmäßig nach, solange das Fenster sichtbar ist, und sofort, wenn es wieder in den Vordergrund kommt
 * (im Hintergrund drosselt der Browser Zeitgeber – ohne das stünde nach dem Zurückwechseln noch der alte Stand da).
 */
export function useNachladen(laden: () => void, ms: number, deps: unknown[]) {
  const aktuell = useRef(laden);
  aktuell.current = laden;
  useEffect(() => {
    const jetzt = () => { if (!document.hidden) aktuell.current(); };
    const t = window.setInterval(jetzt, ms);
    document.addEventListener('visibilitychange', jetzt);
    window.addEventListener('focus', jetzt);
    return () => {
      window.clearInterval(t);
      document.removeEventListener('visibilitychange', jetzt);
      window.removeEventListener('focus', jetzt);
    };
  }, deps);
}
